import React, { useState } from 'react';
import { StepContainer, StepNavigation, ChoiceButtons } from '../components';
import { StepProps, useFormContext } from '../context';

export const Step20D_AprendizadoApp: React.FC<StepProps> = ({ onNext, onPrevious, isLoading }) => {
  const { data, updateField } = useFormContext();
  const [errors, setErrors] = useState<Record<string, string>>({});

  const handleNext = () => {
    const newErrors: Record<string, string> = {};

    if (!data.appLearning) newErrors.appLearning = 'Campo obrigatório';

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    onNext({ appLearning: data.appLearning });
  };

  const handleFieldChange = (value: string) => {
    updateField('appLearning', value);
    if (errors.appLearning) {
      setErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors.appLearning;
        return newErrors;
      });
    }
  };

  return (
    <StepContainer title="">
      <div className="mb-6">
        <p className="font-semibold mb-4">Se precisasse aprender a usar um novo aplicativo ou plataforma para vender produtos, você..</p>
      </div>
      <div>
        <ChoiceButtons
          options={[
            { label: 'Aprenderia sozinha rapidamente.', value: 'learn-quickly' },
            { label: 'Precisaria de ajuda inicial, mas aprenderia com o tempo.', value: 'need-help' },
            { label: 'Teria dificuldade e preferiria apoio mais próximo.', value: 'need-support' },
          ]}
          selected={data.appLearning || ''}
          onSelect={handleFieldChange}
        />
        {errors.appLearning && (
          <p className="text-red-600 text-sm mt-2">{errors.appLearning}</p>
        )}
      </div>

      <StepNavigation onPrevious={onPrevious} onNext={handleNext} isLoading={isLoading} />
    </StepContainer>
  );
};

export default Step20D_AprendizadoApp;
